<div class="layout">
  <mat-sidenav-container autosize class="sidenav-container w-100-percent">
    <mat-sidenav #sidenav class="tenant-sidenav" mode="side" opened="true" (mouseenter)="mouseEnter()" (mouseleave)="mouseLeave()"
      [ngClass]="{'disable-scroll': sidenavService.rightExpanded, 'collapsed': !sidenavService.isShowing && !sidenavService.isExpanded}">
    </mat-sidenav>
    <mat-sidenav-content class="flex justify-center items-center sidenav-content">
      <mat-sidenav-container class="flex-auto tenant-right-container" (backdropClick)="sidenavService.backdropClicked()">
        <mat-sidenav #rightSidenav (closed)="sidenavService.resetAfterClosed()"
                     [(opened)]="sidenavService.rightExpanded"
                     [autoFocus]="false"
                     class="right-sidenav" position="end">
          <ng-container #container></ng-container>
        </mat-sidenav>
        <mat-sidenav-content #scrollableContainer (scroll)="scroll($event)" class="flex-col items-center layout-background content-wrapper" #contentArea>
          <div [ngClass]="{'fixed-topbar': isAWS}">
            <app-header [ngClass]="{'disabled': showLoader}" [tenants]="tenantsList" [selectedTenantId]="selectedTenantId" (selectionChanged)="selectedTenant($event)"></app-header>
            <app-tenant-menu [ngClass]="{'disabled': showLoader}" [tenantId]="tenantId" [selectedTenantId]="selectedTenantId"></app-tenant-menu>
            <div *ngIf="(drInProgress$ | async) && (isDREnabled$ | async) && (drValidated$ | async) && !isDisasterRecoveryPage" class="switch-view flex flex-row w-100-percent">
              <div class="flex flex-row w-100-percent justify-center pt-4 pb-4">
                <span class="mr-8 pt-6">
                <mat-spinner diameter="16"
                    color="primary"
                    mode="indeterminate">
                    </mat-spinner>
                  </span>
                <span class="pt-2 fw-500 fs-14">{{ 'TENANT_LAYOUT.DR_IN_PROGRESS' | transloco }}</span>
                <mat-progress-bar class="w-160 dr-progress" mode="indeterminate"></mat-progress-bar>
                <a href="javascript:void(0);" (click)="onViewDrDetails()" class="link-text fw-500 fs-14">{{ 'TENANT_DASHBOARD.VIEW_DETAILS' | transloco }}</a>
              </div>
            </div>
          </div>
          <div class="content" [ngClass]="{'mt-172': isAWS && (drInProgress$ | async) && (isDREnabled$ | async), 'mt-140': isAWS && (!(drInProgress$ | async) || !(isDREnabled$ | async))}">
            <div [ngClass]="{'disabled': showLoader}">
              <router-outlet></router-outlet>
            </div>
          </div>
          <!-- <app-footer class="footer"></app-footer> -->
        </mat-sidenav-content>
      </mat-sidenav-container>
    </mat-sidenav-content>
  </mat-sidenav-container>
</div>
<div *ngIf="showLoader">
  <mat-card class="flex spinner-container load-spinner">
    <mat-spinner diameter="24"
      color="primary"
      mode="indeterminate">
    </mat-spinner>
  </mat-card>
</div>
